import React from "react"
import { QuotationHotelOptionsByDateHotel } from "../../../../models/axiosModel"
import styles from "../HotelRoomSelectorV2.module.scss"
import { toTitleCase } from "util/textcase"

interface HotelListItemProps {
  hotel: QuotationHotelOptionsByDateHotel
  active: boolean
  fromPrice: number
  selected: boolean
  onClick: () => void
}

const HotelListItem: React.FC<HotelListItemProps> = ({ hotel, active, fromPrice, selected, onClick }) => {
  return (
    <button
      type="button"
      aria-pressed={active}
      className={`${styles.hotelCard} ${active ? styles.hotelCardActive : selected ? styles.hotelCardSelected : ""}`}
      onClick={onClick}
    >
      <div className={styles.hotelInfo}>
        <h4>{toTitleCase(hotel.hotel_name)}</h4>
        <div className={styles.hotelMeta}>
          <span className={styles.stars} aria-label={`${hotel.rating}-star hotel`}>
            {"★".repeat(Math.max(0, Math.min(5, Number(hotel.rating || 0))))}
          </span>
          <span>· {toTitleCase(hotel.city_name)}</span>
        </div>
        <div className={styles.fromPrice}>From VND {Math.max(0, Number(fromPrice || 0)).toLocaleString("en-US")}</div>
      </div>
    </button>
  )
}

export default HotelListItem
